import { getDoc } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import styled from 'styled-components';

import { Context } from '../../index';
import ChatList from '../Chat/components/ChatList';
import Gallery from '../Chat/components/Gallery';
import MessageInput from '../Chat/components/MessageInput';
import MessageListBody from '../Chat/components/MessageListBody';
import useGalleryControls from '../Chat/hooks/useGalleryControls';

const ChatListSider = styled.div`
  display: flex;
  flex-direction: column;
  width: 390px;
  height: calc(100vh - 64px);
  border-right: 1px solid #d7def3;
`;

const MessageList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: calc(100vh - 64px);
  transition: all 0.3s;
`;

const SupportAdmin = ({ supportIds }) => {
  const { firestore, auth } = useContext(Context);
  const [activeChat, setActiveChat] = useState(null);
  const [isChatRoomsLoading, setIsChatRoomsLoading] = useState(true);
  const [supportChats, setSupportChats] = useState(null);
  const user = auth.currentUser;
  const userId = user?.uid;
  const { isGalleryVisible, showGallery, closeGallery, galleryImagePath } = useGalleryControls();
  const [supportChatSnapshot] = useCollection(
    firestore
      .collection('chat_rooms')
      .where('user_ids', 'array-contains', userId)
      .where('room_type', '==', 1),
  );

  useEffect(() => {
    const _supportIds = supportIds.map((item) => item.support_id);
    const getChatRooms = async () => {
      const asyncChatRoomSnapshot =
        supportChatSnapshot?.docs?.map(async (doc) => {
          const _data = doc.data();
          let chatName = _data?.room_name || '';
          const avatarUrl = _data?.room_avatar || '';
          if (_data?.room_type !== '2') {
            const otherUserId = _data?.user_ids.find((user_id) => !_supportIds.includes(user_id));
            if (otherUserId) {
              const otherUserSnapshot = await getDoc(
                firestore.collection('users').doc(otherUserId),
              );
              const otherUser = otherUserSnapshot.data();
              chatName = `${otherUser?.first_name} ${otherUser?.last_name}` || 'Unknown user';
            }
          }
          // console.log('chatName', chatName);
          return {
            id: doc.id,
            data: {
              ..._data,
              chatName,
              avatarUrl,
            },
          };
        }) || [];
      try {
        const _chatRooms = await Promise.all(asyncChatRoomSnapshot);
        const sorted = _chatRooms.sort(
          (a, b) => b.data.last_msg_epoch.seconds - a.data.last_msg_epoch.seconds,
        );
        setSupportChats(sorted);
        setIsChatRoomsLoading(false);
      } catch (e) {
        setIsChatRoomsLoading(false);
      }
    };

    getChatRooms();
  }, [supportChatSnapshot]);

  const selectChat = (id) => setActiveChat(id);

  return (
    <>
      <ChatListSider>
        <ChatList
          isSupportChat
          isChatRoomsLoading={isChatRoomsLoading}
          chatRooms={supportChats || []}
          selectChat={selectChat}
          activeChat={activeChat}
        />
      </ChatListSider>
      <MessageList>
        <MessageListBody
          activeChat={activeChat}
          userId={userId}
          isSupportChat
          showGallery={showGallery}
        />
        <MessageInput activeChat={activeChat} isSupportChat userId={userId} />
      </MessageList>
      <Gallery
        galleryImagePath={galleryImagePath}
        isGalleryVisible={isGalleryVisible}
        closeGallery={closeGallery}
      />
    </>
  );
};

export default SupportAdmin;
